module.exports = __webpack_public_path__ + "languageiconh5-6b605a04.png";